import { styled } from "@mui/material";
import { AnimatePresence, motion } from "motion/react";
import { forwardRef, ComponentProps } from "react";

const StyledTextWrapper = styled("div")(() => ({
  position: "relative",
  overflow: "hidden",
}));
const StyledText = styled(motion.p)(() => ({
  margin: 0,
  padding: 0,
}));

export const TextTransition = forwardRef<
  HTMLParagraphElement,
  ComponentProps<typeof motion.p>
>((props, ref) => {
  return (
    <AnimatePresence mode="popLayout">
      <StyledTextWrapper>
        <StyledText
          key={props.children?.toString()}
          ref={ref}
          variants={{
            up: { y: 50 },
            down: { y: -50 },
          }}
          initial="up"
          animate={{ y: 0 }}
          exit="down"
          transition={{
            type: "spring",
            bounce: 0.5,
            duration: 0.75,
          }}
          {...props}
        />
      </StyledTextWrapper>
    </AnimatePresence>
  );
});
